import { atomFamily, selectorFamily } from 'recoil';
import { ApiClient } from '../../@sprinx/react-after-razzle';
import { GlobalStateRegister } from '../../@sprinx/react-after-razzle/stateStore';
import { apiClientState } from '../appState';

export type ContactSupervisorsParams = { contactId: string };

export type ContactSupervisor = {
  email: string;
  id: string;
  name: string;
};

export async function getContactSupervisors(apiClient: ApiClient, contactId: string): Promise<ContactSupervisor[]> {
  return apiClient.get<ContactSupervisor[], {}>('/v1/users/find-supervisors-for-contact', { contactId });
}

export const contactSupervisorsInitialState = GlobalStateRegister.register(
  atomFamily<ContactSupervisor[] | undefined, ContactSupervisorsParams>({
    key: 'contactSupervisorsInitial',
    default: undefined,
  }),
  'contactSupervisorsInitial',
);

export const contactSupervisorsQuery = selectorFamily<ContactSupervisor[], ContactSupervisorsParams>({
  key: 'contactSupervisors',
  get:
    ({ contactId }) =>
    ({ get }) => {
      const initial = get(contactSupervisorsInitialState({ contactId }));
      if (initial) return initial;

      const apiClient = get(apiClientState);
      return getContactSupervisors(apiClient, contactId);
    },
});
